module.exports = __webpack_public_path__ + "static/media/course.255d905e.png";